export const startAnimation_for_guests = (guestFormIdentifier) => {
  // disable submit button & start animation
  const button = document.querySelector(guestFormIdentifier);
  button.disabled = true;
  button.querySelector('i').classList.add('rotating');
};

export const stopAnimation_for_guests = (guestFormIdentifier) => {
  // enable submit button & stop animation
  const button = document.querySelector(guestFormIdentifier);
  button.disabled = false;
  button.querySelector('i').classList.remove('rotating');
};

export default {
  stopAnimation_for_guests,
  startAnimation_for_guests,
};
